module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div\n    ngeo-map="ctrl.map"\n    ngeo-map-manage-resize="ctrl.manageResize"\n    ngeo-map-resize-transition="ctrl.resizeTransition">\n</div>\n';

}
return __p
}